import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { LocationInterface } from 'src/app/models/location.interface';
import { LocationService } from 'src/app/services/location.service';

@Component({
    selector: 'app-delete-location-modal',
    templateUrl: './delete-location-modal.component.html',
    styleUrls: ['./delete-location-modal.component.scss'],
    standalone: false
})
export class DeleteLocationModalComponent implements OnInit {

  @Input() selectedLocation: LocationInterface;
  @Input() isMultipleDelete: boolean = false; // Nowa właściwość
  @Input() selectedCount: number = 1; // Nowa właściwość
  @Output() closed: EventEmitter<never> = new EventEmitter<never>();

  constructor(public bsModalRef: BsModalRef, private locationService: LocationService, private toastr: ToastrService) { }

  ngOnInit(): void {}

  deleteLocation(): void {
    // Sprawdź czy to wielokrotne usuwanie
    if (this.isMultipleDelete) {
      // Dla wielokrotnego usuwania tylko zamknij modal - logika usuwania jest w komponencie nadrzędnym
      this.closed.emit();
      return;
    }

    // Logika dla pojedynczego usuwania (istniejący kod)
    if (this.selectedLocation && this.selectedLocation.extras.is_candidate) {
      this.locationService
        .locationRejectCandidate(this.selectedLocation.extras.geodata_id)
        .subscribe(
          (response) => {
            this.locationRemoveSuccess('candidate ');
          },
          () => {
            this.locationRemoveFail('candidate ');
          }
        );
    } else if (this.selectedLocation) {
      this.locationService
        .removeLocation(this.selectedLocation.extras.geodata_id)
        .subscribe(
          (response) => {
            this.locationRemoveSuccess();
          },
          () => {
            this.locationRemoveFail();
          }
        );
    }
  }

  locationRemoveSuccess(val?: string): void {
    this.toastr.success(`Location ${val ?? ''}has been deleted`, 'Success');
    this.closed.emit();
  }

  locationRemoveFail(val?: string): void {
    this.toastr.error(`Location ${val ?? ''}has not been deleted`, 'Failure');
  }
}
